import { jsx as t } from "@emotion/react/jsx-runtime";
import { MultiSelect as r } from "./MultiSelect.js";
import { MultiSelectProvider as i } from "./MultiSelectContext.js";
const m = (e) => /* @__PURE__ */ t(i, { ...e, children: /* @__PURE__ */ t(r, {}) });
export {
  m as MultiSelect
};
